import React from "react";
import T from "prop-types";

import { PlaceholderText } from "2g-placeholder";

import { Date } from "b2b/renderers";

import useMessages from "./i18n/useMessages";
import FixniNarokyNasledujiciCount from "./FixniNarokyNasledujiciCount";

export function FixniNarokyNasledujiciItem({ smlouva, vzo, mzo, loading }) {
  const {
    nasledujiciItemSmlouva,
    nasledujiciCountTitleVzo,
    nasledujiciCountTitleMzo
  } = useMessages();
  return (
    <li className={"b2b-FixniNarokyNasledujici-item"}>
      <div>
        <div className="b2b-FixniNarokyNasledujici-itemCislo">
          <span className="b2b-FixniNarokyNasledujici-itemCisloTitle">
            {nasledujiciItemSmlouva()}
          </span>
          <span className="b2b-FixniNarokyNasledujici-itemCisloValue">
            {loading ? (
              <PlaceholderText>25412365</PlaceholderText>
            ) : (
              smlouva.cislo
            )}
          </span>
        </div>
        <div className="b2b-FixniNarokyNasledujici-itemPlatnost">
          {loading ? (
            <PlaceholderText>19. 01. 1970 - 19. 01. 1970</PlaceholderText>
          ) : (
            <>
              <span className="b2b-FixniNarokyNasledujici-itemPlatnostOd">
                <Date val={smlouva.platnostOd} />
              </span>
              <span className="b2b-FixniNarokyNasledujici-itemPlatnostDo">
                <Date val={smlouva.platnostDo} />
              </span>
            </>
          )}
        </div>
      </div>
      <div className="b2b-FixniNarokyNasledujici-counts">
        <FixniNarokyNasledujiciCount
          title={nasledujiciCountTitleVzo()}
          loading={loading}
          {...vzo}
        />
        <FixniNarokyNasledujiciCount
          title={nasledujiciCountTitleMzo()}
          loading={loading}
          {...mzo}
        />
      </div>
    </li>
  );
}

FixniNarokyNasledujiciItem.propTypes = {
  smlouva: T.shape({
    cislo: T.string,
    platnostOd: T.number,
    platnostDo: T.number
  }),
  vzo: T.shape({
    zadane: T.number,
    povolene: T.number
  }),
  mzo: T.shape({
    zadane: T.number,
    povolene: T.number
  }),
  loading: T.bool
};

export default React.memo(FixniNarokyNasledujiciItem);
